// extracted by mini-css-extract-plugin
export default {"stock-detail__container":"styles_stock-detail__container__fDEka"};